module.exports = __webpack_public_path__ + "media/images/application/search-icon-11d1317daa45d7d47b2d499597446284.png";